<template>
  <div class="product-scroll">
    <Top />
    <div class="soso-tab">
      <div class="soso-center">
        <h3 class="soso-title">礼品详情</h3>
      </div>
    </div>

  <div class="cart-mores fix" v-if="Loading"><img src="../assets/car.gif" alt="正在为您加载数据..."></div>
  <template v-else>
    <template v-if="pd.auditStatus == 2">
      <div class="wrap1200 top20 fix" >
        <div class="productLeft">
          <vue-magnify :listImg="this.pd.imageUrl != '' ? this.pd.imageUrl.split(',') : ['http://www.yos168.com/lots-web/images/product/NoPicture.png']"></vue-magnify>
          <!-- <a class="pd-share" href="javascript:void(0);"><i class="icons icon-share"></i><span>分享</span></a> -->
        </div>
        <div class="detailsRight w-s-b">
          <h1 :title='pd.productName' class="ng-binding">{{pd.productName}}</h1>
          <div class="pBatch fix">
            <div class="product-rc">兑换积分
              <h3 v-if="pd.status != 20">
                <IconJifen :points="pd.price" />
              </h3>
              <h3 v-else class="rc-status"><p>暂无报价</p><span>该礼品已下架，非常抱歉！</span></h3>
            </div>
            <div></div>
          </div>

          <div class="pInfo fix">
            <p>礼品编号：<span>{{pd.productCode}}</span></p>
            <p>售价单位：<span>{{pd.saleUnit}}</span></p>
          </div>

          <div class="top20 fix" v-if="pd.status != 20">
            <span class="pStockTips" :class="{'is-err': pd.quantity > pd.stock || pd.stock == 0}">库存 {{pd.stock}}{{pd.saleUnit}}</span>
            <span class="pStockTips" v-if="pd.isLimited === '100'" :class="{'is-err': pd.quantity > pd.remainedQuantity || pd.remainedQuantity == 0}">限购 {{pd.remainedQuantity}}{{pd.saleUnit}}</span> 
          </div>

          <div class="rc-num fix" v-if="pd.quantity > 0">兑换数量：</div>

          <div class="fix top10" v-if="pd.status != 20 && pd.stock != 0">
            <InputNum tag='product'  v-model="pd.quantity" :merchantCode="pd.merchantCode" :productCode="pd.productCode" :min="0" :max="999"/>
          </div>

          <div v-else class="rc-status-btn top20">{{ pd.stock == 0 ? '暂时缺货' : '礼品已下架'}}</div>

          <div class="qr-img">
            <div id="qrcode"></div>
            <p><span>扫一扫</span>微信扫描下单</p>
          </div>
        </div>
      </div>

      <div class="wrap1200 top20 bottom20 fix detailsCont">
        <ul class="tab-hd fix">
            <li class="active">产品介绍</li>
            <li></li>
        </ul>
        <ul class="p-detail-box fix">
          <template v-if="pd.detailUrl">
          <img :src="img" v-for="(img,idxs) in pd.detailUrl.split(',')" :key="idxs">
          </template>
          <template v-if="imageDet.length > 0 && !pd.detailUrl">
          <img :src="url" v-for="(url,idx) in imageDet" :key="idx">
          </template>
        </ul>
      </div>
      <FootCart />
    </template>
    <PInvalid v-else />
  </template>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import QRCode from "qrcodejs2";
import Top from "../components/top";
import vueMagnify from "../components/magnify";
import InputNum from "../components/input-num";
import FootCart from "../components/foot-cart";
import PInvalid from "../components/p-invalid";
import IconJifen from "../components/icon-jifen";

export default {
  name: "top",
  components: {
    Top,
    vueMagnify,
    InputNum,
    FootCart,
    PInvalid,
    IconJifen
  },
  computed: {
    ...mapGetters({
      pd: "productsDetail",
      cart: "carts",
      Loading: "LoadingCart"
    }),
    imageDet() {
      return this.pd.imageUrl.split(',')
    }
  },
  data() {
    return {
      num: 0,
      merchantCode: 0
    };
  },
  created() {
    let oUrl = this.$route.path;
    this.merchantCode = oUrl.substring(
      oUrl.indexOf("/") + 9,
      oUrl.lastIndexOf("/")
    );
    this.$store.dispatch("ALLPRODUCTSDETAIL", {
      merchantCode: this.merchantCode,
      id: this.$route.params.id
    });
  },
  watch: {
    "cart.cartDetails": function(val) {
      if (val.length > 0) {
        this.getNum();
      }
    },
    $route: "qrcode"
  },
  mounted() {
    this.qrcode();
  },
  methods: {
    getNum() {
      let p = this.cart.cartDetails.find(
        (item) => item.productCode === this.pd.productCode
      );
      this.num = (p && p.quantity) || 0;
    },
    qrcode() {
      const url = process.env.VUE_APP_QRCODE + `/point/${this.merchantCode}/products/${this.$route.params.id}`
      setTimeout(() => {
        new QRCode("qrcode", {
          width: 132,
          height: 132,
          text: url,
          colorDark: "#000",
          colorLight: "#fff"
        });
      }, 800)
    }
  }
};
</script>
<style>
.product-scroll {
  /* margin: 0;
  overflow-y: auto;
  height: 100vh; */
}
.p-detail-box {
  min-height: 100px;
}
.p-detail-box img {
  display: block;
  margin: auto;
  max-width: 1200px;
}
.soso-tab {
  width: 100%;
  height: 50px;
  margin: 0 auto;
  padding: 0;
  position: relative;
  border-bottom: 1px solid #ddd;
}
.soso-center {
  width: 1200px;
  line-height: 50px;
  margin: auto;
  text-align: left;
  overflow: hidden;
}
.soso-title {
  width: 200px;
  font-size: 18px;
  display: inline;
  color: #666;
}

.productLeft {
  float: left;
  text-align: left;
}
.icon-share {
  display: inline-block;
  width: 14px;
  vertical-align: -4px;
  margin-right: 6px;
  height: 17px;
  background-position: 0 -124px;
}
.product-rc {
  font-size: 14px;
}
.product-rc h3 {
  font-weight: inherit;
  font-size: 18px;
  color: #ffcc00;
  display: inline-block;
  margin-left: 12px;
  vertical-align: middle;
}
.product-rc h3 span {
  font-size: 14px;
  vertical-align: 1px;
}
.product-rc h3 img {
  vertical-align: -4px;
  margin-right: 6px;
}
.rc-status p {
  color: red;
}
.rc-status span {
  color: #999;
}
.rc-status-btn {
  border: 2px solid #cfcfd2;
  display: inline-block;
  border-radius: 60px;
  height: 36px;
  width: 120px;
  text-align: center;
  font-size: 16px;
  overflow: hidden;
  padding: 0;
  outline: 0;
  line-height: 36px;
}
.detailsRight {
  position: relative;
  float: right;
  width: 720px;
  min-height: 500px;
  padding: 0 0 20px 20px;
  border-left: 1px solid #e7e7e7;
  color: #666;
  text-align: left;
}
.detailsRight h1 {
  padding: 10px 0;
  margin-bottom: 10px;
  font-size: 18px;
  font-weight: 400;
  color: #333;
  word-wrap: break-word;
  white-space: normal;
  word-break: break-all;
}
.detailsRight .pBatch {
  line-height: 30px;
  color: #333;
  background: #f9f9f9;
  padding: 25px 20px;
  border-bottom: 1px solid #ed6c00;
  margin: 10px 0;
}
.detailsRight .pInfo {
  border-bottom: 1px solid #e7e7e7;
  padding: 10px 0;
}
.detailsRight .pInfo p {
  float: left;
  width: 80%;
  margin-left: 20px;
  line-height: 30px;
  overflow: hidden;
}
.detailsCont {
  background: #fff;
  border: 1px solid #e7e7e7;
}
.detailsCont .tab-hd {
  background: #f8f8f8;
  border-bottom: 1px solid #e7e7e7;
}
.tab-hd > li {
  float: left;
  padding: 0 20px;
  cursor: pointer;
}
.detailsCont .tab-hd li {
  width: 120px;
  line-height: 40px;
  font-size: 14px;
  border-right: 1px solid #e7e7e7;
}
.detailsCont .tab-hd li.active {
  line-height: 38px;
  padding-bottom: 2px;
  margin: -1px 0;
  color: #ed6c00;
  background: #fff;
  border-top: 2px solid #ed6c00;
}
.rc-num {
  margin: 20px 0 0 10px;
}
.pStockTips {
  background-color: rgba(245, 245, 245, 1);
  border-radius: 20px;
  padding: 2px 15px;
  color: #666;
  font-size: 12px;
  line-height: 22px;
  float: left;
  margin-right: 16px;
}
.qr-img {
  position: absolute;

  right: 0;
  bottom: 0;
  padding: 10px;
  background: #f8f8f8;
  z-index: 11;
}
.qr-img {
  padding-top: 5px;
  text-align: center;
}
.qr-img img {
  width: 76px;
}
.qr-img:hover img {
  width: 124px;
}
.qr-img p span {
  display: block;
}
.qr-img:hover p span {
  margin-right: 10px;
  display: inline-block;
}
.is-err {
  color: #ff0000;
  background-color: #ffe5e5;
}
.cart-mores {
  margin: 100px auto;
  color: #999;
  width: 1200px;
}
</style>
